//
// Imports
//

import * as BrowserUtilities from "@donutteam/browser-utilities";

//
// Component
//

export function initialiseGlobalQuickDrawer(globalQuickDrawer: HTMLElement)
{
	const overflowButtonsToggle = BrowserUtilities.ElementClientLib.getElement(globalQuickDrawer, ".overflow-buttons-toggle");

	const overflowButtonsContainer = BrowserUtilities.ElementClientLib.getElement(globalQuickDrawer, ".overflow-buttons-container");

	if (overflowButtonsToggle != null && overflowButtonsContainer != null)
	{
		overflowButtonsToggle.addEventListener("click", 
			() =>
			{
				if (overflowButtonsContainer.classList.contains("open"))
				{
					overflowButtonsToggle.textContent = "Show more";
					overflowButtonsContainer.classList.remove("open");
				}
				else
				{
					overflowButtonsToggle.textContent = "Show less";
					overflowButtonsContainer.classList.add("open");
				}
			});
	}

	globalQuickDrawer.classList.add("initialised");
}

export function initialiseGlobalQuickDrawers()
{
	const globalQuickDrawers = document.querySelectorAll<HTMLElement>(".component-global-quick-drawer:not(.initialised)");

	console.log("[GlobalQuickDrawer] Initialising " + globalQuickDrawers.length + " instances...");

	for (const globalQuickDrawer of globalQuickDrawers)
	{
		try
		{
			initialiseGlobalQuickDrawer(globalQuickDrawer);
		}
		catch (error)
		{
			console.error("[GlobalQuickDrawer] Error initialising:", globalQuickDrawer, error);
		}
	}
}